import { SelectOption } from "@repo/ui";
import { GroupByOption } from "@repo/types";

export const MatterTableGroupByOptions: SelectOption[] = [
    { label: 'No Grouping', value: GroupByOption.NONE },
    { label: 'Group by Client', value: GroupByOption.CLIENT }
];

export const AR_COLLECTIONS_LOCATION = "AR-Collections"